module.exports = __webpack_public_path__ + "static/media/logo2.ced89705.png";